import { createContext } from "react";
import { IAddon } from "./types";

export const AddOnsCatalogContext = createContext<IAddon[]>([]);
